
import { Fragment } from 'react';
import caseloadDisplay from "../../api/models/caseloadDisplay";
import DatePicker from 'react-datepicker';
import EditModal from "../editModal";

type Props = {
    open?: boolean;
    onCancel: () => void;
    onSave: () => void;
    allowSave?: boolean;
    saveText?: string;
    caseload: caseloadDisplay;
    disciplineEndDate: Date;
    setDisciplineEndDate: React.SetStateAction<any>;
    minDate?: Date;
    isDischarge?: boolean;
};

const DischargeModal = ({
    open = false,
    allowSave = true,
    onCancel,
    onSave,
    saveText = 'Proceed',
    caseload,
    disciplineEndDate,
    setDisciplineEndDate,
    minDate = undefined,
    isDischarge = true
}: Props) => {
    return (
        <EditModal
            saveText={saveText}
            allowSave={allowSave}
            open={open}
            onCancel={onCancel}
            onSave={onSave}
        >
            <Fragment>
                <div className='grid grid-cols-1 mb-16'>
                    <label className='text-lg'>{isDischarge ? 'Discharge' : 'Remove'} Student</label>
                    <p>
                        {isDischarge ?
                            `Are you sure you want to discharge this student? This action will
                        remove the student from all
                        ${caseload !== undefined ? caseload.disciplineName : ''} services for all
                        therapists.` : `Are you sure you want to remove from caseload? The student will come off the caseload but will remain in the system as eligible for services.`}
                    </p>
                    <div className='pb-16 mt-3 mb-16'>
                        <label className='primary'>{isDischarge ? 'Discharge Date' : 'Date to End Caseload'}</label>
                        <DatePicker
                            className='block mt-1 primary'
                            selected={disciplineEndDate ?? new Date()}
                            onChange={(date: Date) => setDisciplineEndDate(date!)}
                        //minDate={disciplineEndDate}
                        />
                    </div>
                </div>
            </Fragment>
        </EditModal>
    );
};

export default DischargeModal;